import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const EmergencyContactsPage = lazyWithRetry(
  () => import("./ui/EmergencyContactsPage"),
  "EmergencyContactsPage",
);

/**
 * Rutas de contactos de emergencia
 */
const emergencyContactsRoutes = buildRoutes([
  {
    path: "/alarmcontrol",
    element: EmergencyContactsPage,
    roles: [3, 4, 5],
  },
]);

export default emergencyContactsRoutes;
